import { AuthenticationService } from "./auth.service";
import { AlertService } from "./alert.service";

let timeout: ReturnType<typeof setTimeout> | null = null;
let iniciado = false;

const TEMPO_INATIVO = 90 * 60 * 1000; // 1h30


export function iniciarControleSessao(): void {
  if (iniciado) return;
  iniciado = true;

  const resetTimer = (): void => {
    if (!AuthenticationService.isAuthenticated()) return;
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
    AlertService.warn("Sessão irá expirar em breve! Por favor, interaja para manter-se logado.", { autoClose: 5000 });
      setTimeout(() => {
        encerrarSessao();
      }, 3000);
    }, TEMPO_INATIVO);
  };

  globalThis.addEventListener("mousemove", resetTimer);
  globalThis.addEventListener("keydown", resetTimer);
  globalThis.addEventListener("click", resetTimer);
  globalThis.addEventListener("scroll", resetTimer);

  globalThis.addEventListener("storage", (event: StorageEvent) => {
    if (event.key === "logout") {
      encerrarSessao();
    }
  });
  resetTimer();
}

export function pararControleSessao(): void {
  if (timeout) clearTimeout(timeout);

  timeout = null;
  iniciado = false;
}

export function encerrarSessao(): void {
  pararControleSessao();
  AuthenticationService.logout();
}